import { AdminUsersManagement } from "@/components/admin/AdminUsersManagement";

export default function ConfiguracoesUsuarios() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Usuários Administradores</h1>
        <p className="text-muted-foreground">
          Gerencie os usuários com permissão de acesso ao painel administrativo
        </p>
      </div>

      <AdminUsersManagement />
    </div>
  );
}
